import { $Q, $Qll } from '../utils/query-selector';
import { chageStepForm } from './form-funnel';
import { nextStep } from './funnel';
import { funnelValidation } from './stock-variant';
import { queryVariants } from './variants-change';
import { showZoomMobile } from './zoom-variant-modal';

/**
 * @param {HTMLElement} parent - Dom element parent of all seletors options
 * @returns Array of nodes
 */
const options = (parent) => $Qll('.js-option', parent);

/**
 * @param {Array} options - Array of option names
 * @returns separate options with "/"
 */
const buildOption = (options) => options.join(' / ');

/**
 * optionChecked
 * Iterates and searches for the options that were selected
 *
 * @param {HTMLElement} parent - Dom element parent of all seletors options
 * @returns A variant name - string reference
 */
export function optionsChecked(parent, array) {
  let myOptions = [];

  options(parent).forEach((option) => {
    if (option.type === 'radio') {
      if (option.checked === true) {
        myOptions = [...myOptions, option.value];
      }
    } else {
      myOptions = [...myOptions, option.value];
    }
  });

  if (array === true) {
    return myOptions;
  }

  return buildOption(myOptions);
}

/**
 * selectVariant
 * Searches for a selected variant in an object stored in the DOM
 * (input[id="variants"])
 *
 * @param {HTMLElement} parent - Dom element parent of all seletors options
 * @returns Replacement of id in the dom (input[name="id"]) and filtered variant
 */
function selectVariant(parent) {
  const variantName = optionsChecked(parent, false);
  const variants = JSON.parse($Q('#variants', parent).value);

  const variantFilter = variants.find(
    (variant) => variant.title === variantName);

  $Q('[name="id"]', parent).value = variantFilter.id;

  return variantFilter
}

/**
 * Go next or back slide with the variant changes
 * With slideTo method can chane to slide with the index
 * Get index of the variante
 * @param {node} target - node with listen change
 * @param {object} swiperProductInstance - Instance of Swiper
 * @param {number} position - new slide position
 * @author Daniel Santos
 */
function nextSlideToVariant({ target }, swiperProductInstance, position) {
  if (!target.classList.contains('option1') || Number.isNaN(position)) return;

  swiperProductInstance && swiperProductInstance.slideTo(position - 1, 300);
}

/**
 * Remove css class
 * @param {node} el node to listen change event
 * @param {string} cssClass - css class to validate
 * @see unblockStep
 */
function disabledButton(el, cssClass = 'disabled') {
  if (el && el.classList.contains(cssClass)) el.classList.remove(cssClass);
}

/**
 * unblock next step in funnel v2
 * @param {object} e - event change
 * @returns null -  stop called
 */
function unblockStep(e) {
  if (e.target.dataset.funnelType !== 'main') return;

  if (e.target.checked) {
    $Qll('.funnel-steps__step.step').forEach((step, i) => {
      disabledButton(step);
      disabledButton($Qll('.js-btn-next-step')[i]);
    });
  }
}

/**
 * iterationOptions
 * Detects a change of state on each option selector
 *
 * @param {HTMLElement} parent - Dom element parent of all seletors options
 * @returns Iteration of all selector
 */
function iterationOptions(parent, swiperProductInstance) {
  return options(parent).forEach((option) => {
    option.addEventListener('change', (e) => {
      const variant = selectVariant(parent);
      const imagePosition = variant.featured_image?.position
      queryVariants(e);
      funnelValidation();
      nextStep(parent);
      nextSlideToVariant(e, swiperProductInstance, imagePosition);
      unblockStep(e);
      chageStepForm();
      if (window.matchMedia("(max-width: 992px)").matches) {
        showZoomMobile();
      }
    });
  });
}

/**
 * variantOnChange
 * Adds the functionality in the variant selection group
 *
 * @param {String} component - It is the reference in the dome of all
 * input-selector (variant selection) groups by product
 * @returns Iterator function on each input-selector
 */
export const variantOnChange = (component, swiperProductInstance) => {
  const parents = $Qll(component);

  if (parents.length > 1) {
    return parents.forEach((parent) => {
      iterationOptions(parent, swiperProductInstance);
    });
  }

  return iterationOptions(parents[0], swiperProductInstance);
};

export const selectFirstVariant = () => {
  const firstVariant = $Q('.variant__wrapper .op-stock-js');
  const secondVariant = document.querySelectorAll('.variant__wrapper .op-stock-js')[1];

  if (!firstVariant) return;
  if (window.location.href.indexOf("abonnement") <= -1) {
    firstVariant.click();
  } else {
    secondVariant.click();
  }
};
